import Modal from "components/atom/Modal.tsx";
import designerPng from 'assets/images/designer.png'
import {useTranslation} from "react-i18next";

function ActionBlockedModal(props: {
    isOpen: boolean,
    onClose: () => void,
    children?: React.ReactNode
}) {
    const {onClose, isOpen, children} = props
    const {t} = useTranslation()

    if (!isOpen) {
        return null
    }


    return (
        <Modal flexibleHeight className="-action-blocked" onClose={onClose}>
            <div className="w-full">
                <img src={designerPng} className="mx-auto block h-[200px] w-auto"/>
                <h2 className="text-2xl pb-3 text-center font-semibold">
                    {t('oups')}
                </h2>
                <div className="">
                    {children}
                </div>
            </div>
        </Modal>
    )
}


export default ActionBlockedModal
